import * as React from 'react'
import { Dialog } from 'primereact/dialog'

export type ProgressDialogRef = {
    /**
     * 다이얼로그를 표시한다.
     */
    show(): void
    /**
     * 다이얼로그를 닫는다.
     */
    hide(force?: boolean): void
}

export const ProgressDialog = React.forwardRef<ProgressDialogRef, {}>(
    (nullProps, ref) => {
        React.useImperativeHandle(
            ref,
            () => ({
                show() {
                    setVisible(true)
                    document.body.classList.add('loading-one') // 해당 class 있을시 화면로딩 숨김
                },

                hide() {
                    setVisible(false)
                    if (!document.querySelector('.ibk-loading')) {
                        document.body.classList.remove('loading-one')
                    }
                },
            }),
            []
        )
        const [visible, setVisible] = React.useState(false)

        if (!visible) {
            return null
        }

        return (
            <Dialog
                visible={true}
                draggable={false}
                onHide={() => {}}
                closable={false}
                dismissableMask={false}
                maskClassName="dialog-loading"
                className="-hide-header"
                transitionOptions={{ timeout: 0 }}
            >
                <img
                    src="/assets/images/common/icon-loading-ani.svg"
                    alt="로딩중"
                    width={92}
                    height={90}
                />
            </Dialog>
        )
    }
)
